import apiClient from './client';
import { endpoints } from './endpoints';
import type { TrainingVideo } from '@/types';

export const trainingVideoService = {
  async list(trainingId: string): Promise<TrainingVideo[] | unknown> {
    const response = await apiClient.get(endpoints.trainingVideos.list(trainingId));
    return response.data;
  },
  async upload(trainingId: string, file: File): Promise<unknown> {
    const formData = new FormData();
    formData.append('video', file);
    const response = await apiClient.post(endpoints.trainingVideos.upload(trainingId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  async delete(trainingId: string, videoId: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.trainingVideos.delete(trainingId, videoId));
    return response.data;
  },
  async reorder(trainingId: string, videoIds: string[]): Promise<unknown> {
    const response = await apiClient.put(endpoints.trainingVideos.reorder(trainingId), {
      videoIds,
    });
    return response.data;
  },
};

export default trainingVideoService;
